import { useEffect, useState } from "react"
import { simpleGetCallWithErrorResponse } from "../../api/ApiServices"
import ApiConfig from "../../api/ApiConfig"



function Personality({ userId }) {


    const [personlityDetails, setPersonalityDetails] = useState({})

    const getPersonalityDetails = () => {

        simpleGetCallWithErrorResponse(ApiConfig.GET_USER_TRAITS + userId).then((res) => {

            if (res?.json?.Success) {
                setPersonalityDetails(res?.json?.Data)
            } else {
                setPersonalityDetails({})
            }

        })

    }


    useEffect(() => {

        getPersonalityDetails()

    }, [userId])


    return (
        <div className="">
            <div className="personal-heading-main">
                <h3>Personality Details</h3>

            </div>
            <div className="lineSeperate2"></div>
            <div className="row p-0">
                <div className="col-md-6 mt-2">
                    <label htmlFor="">Primary Profile</label>
                    <p className="mb-3">
                        {personlityDetails?.PrimaryProfile}
                    </p>
                </div>
                <div className="col-md-6 mt-2">
                    <label htmlFor="">Secondary Profile</label>
                    <p className="mb-3">
                        {personlityDetails?.SecondryProfile}
                    </p>
                </div>
                <div className="col-md-12 mt-2">
                    <label htmlFor="">Internal Personality</label>
                </div>
                <div className="col-md-3 mt-2">
                    <label htmlFor="">Dominance</label>
                    <p className="mb-3">
                        {personlityDetails?.K3MostD}
                    </p>
                </div>
                <div className="col-md-3 mt-2">
                    <label htmlFor="">Influence</label>
                    <p className="mb-3">
                        {personlityDetails?.K3MostI}
                    </p>
                </div>
                <div className="col-md-3 mt-2">
                    <label htmlFor="">Steadiness</label>
                    <p className="mb-3">
                        {personlityDetails?.K3MostS}
                    </p>
                </div>
                <div className="col-md-3 mt-2">
                    <label htmlFor="">Compliance</label>
                    <p className="mb-3">
                        {personlityDetails?.K3MostC}
                    </p>
                </div>
                <div className="col-md-12 mt-2">
                    <label htmlFor="">External Personality</label>
                </div>
                <div className="col-md-3 mt-2">
                    <label htmlFor="">Dominance</label>
                    <p className="mb-3">
                        {personlityDetails?.K3LeastD}
                    </p>
                </div>
                <div className="col-md-3 mt-2">
                    <label htmlFor="">Influence</label>
                    <p className="mb-3">
                        {personlityDetails?.K3LeastI}
                    </p>
                </div>
                <div className="col-md-3 mt-2">
                    <label htmlFor="">Steadiness</label>
                    <p className="mb-3">
                        {personlityDetails?.K3LeastS}
                    </p>
                </div>
                <div className="col-md-3 mt-2">
                    <label htmlFor="">Compliance</label>
                    <p className="mb-3">
                        {personlityDetails?.K3LeastC}
                    </p>
                </div>
                <div className="col-md-12 mt-2">
                    <label htmlFor="">Both</label>
                </div>
                <div className="col-md-3 mt-2">
                    <label htmlFor="">Dominance</label>
                    <p className="mb-3">
                        {personlityDetails?.K3DiffD}
                    </p>
                </div>
                <div className="col-md-3 mt-2">
                    <label htmlFor="">Influence</label>
                    <p className="mb-3">
                        {personlityDetails?.K3DiffI}
                    </p>
                </div>
                <div className="col-md-3 mt-2">
                    <label htmlFor="">Steadiness</label>
                    <p className="mb-3">
                        {personlityDetails?.K3DiffS}
                    </p>
                </div>
                <div className="col-md-3 mt-2">
                    <label htmlFor="">Compliance</label>
                    <p className="mb-3">
                        {personlityDetails?.K3DiffC}
                    </p>
                </div>
            </div>
        </div>
    )

}

export default Personality